// const msalConfig = {
//   auth: {
//     clientId: 'CLIENT-ID',
//     authority: 'https://login.microsoftonline.com/a56222e7-2ad0-4357-81fc8485f79f59ec',
//     redirectUri: 'http://localhost:3000/'
//   },
//   cache: {
//     cacheLocation: "sessionStorage",
//     storeAuthStateInCookie: false
//   },
// };
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../authConfig";
const pca = new PublicClientApplication(msalConfig);
export function getTokenMicro() {
  const accounts = pca.getAllAccounts();
  return new Promise((resolve, reject) => {
    pca
      .acquireTokenSilent({
        scopes: ["https://graph.microsoft.com/.default"],
        account: accounts[0],
      })
      .then((response) => {
        const accessToken = response.idToken;
        resolve(accessToken);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
